const upload = {
  computed: {
    validationAccept() {
      return 'csv,xls,xlsx'
    },
    rules() {
      const rules = 'required|size:10000|ext:'
      return rules + this.validationAccept
    },
    extensionsMap() {
      return {
        xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        xls: 'application/vnd.ms-excel',
        csv: 'text/csv'
      }
    },
    acceptedFileExtensions() {
      return Object.values(this.extensionsMap).join(',')
    }
  }
}

export default upload
